import { createContext } from 'react';

export interface TenantContext {
  readonly slug: string;
  readonly tenantId: string;
  readonly displayName: string;
}

export const TenantCtx = createContext<TenantContext | null>(null);
